import { PublicPage } from 'api/website';

type Props = {
  content: PublicPage;
};

export function getContentOffsetAnchors({ content }: Props): boolean {
  return content.contentBlocks.some(
    (block) =>
      block.type === 'STICKY_HEADER_LINKS_GRAD' ||
      block.type === 'STICKY_HEADER_LINKS'
  );
}
